import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const CopySpacePermissionsAndDefaultPermissionsLoader: LoadableType<{
	secondaryButtons?: JSX.Element;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopySpacePermissionsAndDefaultPermissions" */ './CopySpacePermissionsAndDefaultPermissions.tsx'
			)
		).CopySpacePermissionsAndDefaultPermissions,
});
